import { PensionPlanTransfer } from './interfaces/PensionPlanTransfer';

/**
 * De la petición recién creada, el id con el que se puede pedir su firma.
 *
 * 🔴 Es el UUID de la FILA (`id`), no el `requestId` de negocio
 * (`TR-2026-00001`). Los dos vienen en la misma respuesta y el segundo es el
 * que se le enseña al cliente en pantalla, así que es fácil coger el que no es:
 * el boletín cuelga de la fila, y comparsa busca la petición por su UUID —con
 * la referencia de negocio no encontraría ninguna y la firma se quedaría sin
 * poder arrancar.
 *
 * Devuelve `null` si no viene, y también si la petición nace **sin plan de
 * destino**: mejor no ofrecer el botón que ofrecer uno que va a fallar siempre.
 */
export function resolveSignableTransferId(
	created?: Partial<PensionPlanTransfer> | null
): string | null {
	const id = (created?.id ?? '').trim();
	if (!id) return null;

	// Y tiene que traer plan de destino: sin él el backend rechaza la firma
	// —el boletín saldría con el destino en blanco— y el botón solo daría un
	// error. La petición se ha creado bien; lo que no se puede es firmarla aún.
	const destino = (created?.selectedArcaPlanId ?? '').trim();
	return destino ? id : null;
}
